/**
 * Resolve Stripe Checkout currency for Pro prices (PLN / EUR / USD).
 * Prefers browser locale + America/* timezone over app i18n (`en` alone → EUR).
 */
export function resolveCheckoutCurrency(i18nLanguage?: string): 'pln' | 'eur' | 'usd' {
  const appLang = String(i18nLanguage || '').toLowerCase();
  if (appLang.startsWith('pl')) return 'pln';

  const nav =
    typeof navigator !== 'undefined' ? String(navigator.language || '').toLowerCase() : '';
  if (nav.startsWith('en-us') || nav === 'en_us') return 'usd';
  if (nav.startsWith('pl')) return 'pln';

  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz.startsWith('America/')) return 'usd';
  } catch {
    /* ignore */
  }

  if (appLang.startsWith('en-us') || appLang === 'en_us') return 'usd';
  return 'eur';
}
